import { ICSSInJSStyle } from "@fluentui/react-northstar";

export const loaderWithProviderStyles: ICSSInJSStyle = {
  flex: 1,
  justifyContent: "center",
  minHeight: "100%",
};
